import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MenuIcon from '@mui/icons-material/Menu';
import PinterestIcon from '@mui/icons-material/Pinterest';
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileDrawer from './MobileDrawer';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = [
    { name: 'Products', path: '/products', dataTestid: "nav-products-button" },
    { name: 'Gallery', path: '/gallery', dataTestid: "nav-gallery-button" },
    { name: 'Wallet Designer', path: '/configurator', dataTestid: "nav-design-button" },
    { name: 'Reviews', path: '/reviews', dataTestid: "nav-reviews-button" },
    { name: 'Events', path: '/events', dataTestid: "nav-events-button" },
    { name: 'About', path: '/about', dataTestid: "nav-about-button" },
    { name: 'Shop', path: 'https://kbrosleather.etsy.com', external: true, dataTestid: "nav-shop-button" },
  ];

  const socialLinks = [
    {
      icon: <FacebookIcon />,
      url: 'https://facebook.com/kbrosleather',
      name: 'Facebook',
    },
    {
      icon: <InstagramIcon />,
      url: 'https://instagram.com/kbrosleather',
      name: 'Instagram',
    },
    {
      icon: <PinterestIcon />,
      url: 'https://pinterest.com/kbrosleather',
      name: 'Pinterest',
    },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AppBar position="sticky" sx={{ bgcolor: '#264653' }}>
      <Container>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, display: { md: 'none' } }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="h6"
              sx={{ cursor: 'pointer', display: { xs: 'none', sm: 'block' } }}
              onClick={() => navigate('/')}
              data-testid={'company-logo-header'}
            >
              KBros Leather
            </Typography>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
            {navItems.map((item) => (
              <Button
                key={item.name}
                sx={{
                  color: location.pathname.startsWith(item.path) && !item.external ? '#f4a261' : 'white',
                  fontWeight: location.pathname.startsWith(item.path) && !item.external ? 'bold' : 'normal',
                }}
                data-testid={item.dataTestid}
                onClick={() => {
                  if (item.external) {
                    window.open(item.path, '_blank', 'noopener,noreferrer'); // Open external links in new tab
                  } else {
                    navigate(item.path);
                  }
                }}
              >
                {item.name}
              </Button>
            ))}
            <Box sx={{ ml: 2 }}>
              {socialLinks.map((link) => (
                <Tooltip key={link.name} title={link.name}>
                  <IconButton
                    component="a"
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: 'white' }}
                    data-testid={`${link.name}-button`}
                  >
                    {link.icon}
                  </IconButton>
                </Tooltip>
              ))}
            </Box>
          </Box>
        </Toolbar>
      </Container>
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { md: 'none' } }}
      >
        <MobileDrawer
          navItems={navItems}
          socialLinks={socialLinks}
          location={location}
          navigate={navigate}
          onClose={handleDrawerToggle}
        />
      </Drawer>
    </AppBar>
  );
}

export default Navbar;
